// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "swiper" + "." + "9994d3a2" + ".bundle.js";
};